import { useInjection } from "@linkfluence/core/di";
import { getAppUrl } from "@linkfluence/konf";
import { useQuery } from "@tanstack/react-query";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useSaveDiscoverySnapshot(snapshot: InsightPage) {
  const { id } = useCurrentProject();
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { isLoading, isError, isSuccess, data } = useQuery(
    ["save-discovery-snapshot", { id, snapshot }],
    () => repository.saveDiscoverySnapshot(id, snapshot)
  );
  return {
    isLoading,
    isError,
    isSuccess,
    snapshotUid: data ? data.s3Id : "",
    previewLink: data ? `${getAppUrl("public_pages")}?uid=${data.s3Id}` : "",
  };
}
